/**
 * AI Estimator FAQ — exclusive accordion (one panel open at a time).
 * Markup keeps `hidden` for no-JS; once JS runs, panels animate via CSS grid (`0fr` / `1fr`).
 */
function refreshScrollTrigger() {
  if (typeof window.ScrollTrigger !== "undefined") {
    window.requestAnimationFrame(() => {
      window.ScrollTrigger.refresh();
    });
  }
}

function scheduleLayoutRefreshAfterAccordion() {
  window.setTimeout(() => {
    refreshScrollTrigger();
  }, 480);
}

function initEstimatorFaqAccordion() {
  const root = document.querySelector(".estimator-faq__list");
  if (!root) return;

  const items = root.querySelectorAll(".estimator-faq__item");

  root.classList.add("estimator-faq__list--ready");
  items.forEach((article) => {
    const panel = article.querySelector(".estimator-faq__panel");
    if (!panel) return;
    panel.removeAttribute("hidden");
    panel.setAttribute(
      "aria-hidden",
      article.classList.contains("is-open") ? "false" : "true",
    );
  });

  function closeAll() {
    items.forEach((article) => {
      article.classList.remove("is-open");
      const btn = article.querySelector(".estimator-faq__trigger");
      const panel = article.querySelector(".estimator-faq__panel");
      if (btn) btn.setAttribute("aria-expanded", "false");
      if (panel) panel.setAttribute("aria-hidden", "true");
    });
  }

  items.forEach((article) => {
    const btn = article.querySelector(".estimator-faq__trigger");
    const panel = article.querySelector(".estimator-faq__panel");
    if (!btn || !panel) return;

    article.addEventListener("click", (e) => {
      /* Let users interact with answer copy without toggling closed */
      if (article.classList.contains("is-open") && panel.contains(e.target)) {
        return;
      }

      const wasOpen = article.classList.contains("is-open");
      closeAll();
      if (!wasOpen) {
        article.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
        panel.setAttribute("aria-hidden", "false");
      }
      scheduleLayoutRefreshAfterAccordion();
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initEstimatorFaqAccordion);
} else {
  initEstimatorFaqAccordion();
}
